import { useMemo, useState } from 'react';

import { NOT_ASSIGNED_USER } from '@/features/header/consts/user';
import { useAuth } from '@/hooks/useAuth';
import { selectUser, useAuthStore } from '@/stores/useAuthStore';

export const useUserTile = () => {
  const [open, setOpen] = useState(false);

  const user = useAuthStore(selectUser);

  const { logout } = useAuth();

  const handleLogout = () => {
    setOpen(false);
    logout();
  };

  const initials = useMemo(() => {
    if (!user) return NOT_ASSIGNED_USER.initials;
    const parts = user.Name.trim().split(' ');
    return parts
      .map((p) => p[0]?.toUpperCase())
      .filter(Boolean)
      .slice(0, 2)
      .join('');
  }, [user?.Name]);

  const userName = user?.Name ?? NOT_ASSIGNED_USER.Name;
  const companyName = user?.Companies[0]?.Name ?? NOT_ASSIGNED_USER.Companies[0].Name;

  return { open, setOpen, userName, companyName, initials, handleLogout };
};
